import CustomLabel from '@/components/custom-label';
import { css } from '@emotion/react';
import { Col, Form, Input, Row } from 'antd';

export const ProductDetails = () => {
    return (
        <div css={containerStyles}>
            <Row gutter={16} css={fieldStyles} align="middle">
                <Col span={24}>
                    <Form.Item
                        label={<CustomLabel text="Mô tả ngắn" />}
                        name="shortDesc"
                        labelCol={{ span: 6 }}
                        css={customMarginInput} 
                    >
                        <Input maxLength={5000} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16} css={fieldStyles} align="middle">
                <Col span={24}>
                    <Form.Item
                        label={<CustomLabel text="Từ khóa nhãn sản phẩm" />}
                        name="tag"
                        labelCol={{ span: 6 }}
                        css={customMarginInput} 
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16} css={fieldStyles} align="middle">
                <Col span={12}>
                    <Form.Item
                        label={<CustomLabel text="ID Thực phẩm tương ứng" />}
                        name="idFood"
                        labelCol={{ span: 12 }}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={<CustomLabel text="Thực phẩm tương ứng" />}
                        name="nameFood"
                        labelCol={{ span: 12 }}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
};

const containerStyles = css`
  width: 100%;
  margin-top: 1rem;
`;

const fieldStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-form-item {
    .ant-form-item-label {
      display: flex;
      align-items: center;
      margin-right: 2rem;
      text-align: start;

      label {
        &::after,
        &::before {
          display: none !important;
        }
      }
    }
    .ant-form-item-control-input {
      .ant-input {
        font-size: 14px !important;
        padding: 0.8rem 1.2rem !important;
        text-overflow: ellipsis !important;
      }
    }

    .ant-form-item-control-input-content .ant-input {
      height: 3.2rem !important;
    }
  }

  input {
    flex: 1;
  }

  .ant-input-affix-wrapper {
    font-size: inherit !important;
  }
`;

const customMarginInput = css`
  .ant-form-item-label {
    margin-right: 1.6rem !important;
  }
`